// @ts-nocheck

import { createSelector } from 'reselect';

import { selectGRUserNotifications } from '../../modules/gift-race/selectors/user';
import { type Selector } from '../../types/selectors';

const selectNbGRNotifications: Selector<number> = createSelector(
  [selectGRUserNotifications],
  (notifications) => notifications?.length ?? 0,
);

type GRButtonPropsType = {
  nbGRNotifications: number;
};

const selectGRButtonProps: Selector<GRButtonPropsType> = createSelector(
  [selectNbGRNotifications],
  (nbGRNotifications) => ({
    nbGRNotifications,
  }),
);

export default selectGRButtonProps;
